import IAction from "../store/IAction"
import InitState from "../store/initState"
import addressReducer from "./addressReducer"
import ICreateApplicationForReorderingOfCertificateVm from "../models/issuingAuthority/ICreateApplicationForReorderingOfCertificateVm"
import { CertificateType } from "../models/flags/CertificateType"
import { CertificateProcessType } from "../models/flags/CertificateProcessType"
import { PaymentType } from "../models/enums/PaymentType"
import ICompanyVm from "../models/shared/ICompanyVm"
import { companyReducer } from "./companiesReducer"

const UPDATE_APPLICATION_ID = "BAT2/applicationForExempted/UPDATE_APPLICATION_ID"
const UPDATE_CERTIFICATE_PROCESS_TYPE = "BAT2/applicationForExempted/UPDATE_CERTIFICATE_PROCESS_TYPE"
const UPDATE_CERTIFICATE_TYPE = "BAT2/applicationForExempted/UPDATE_CERTIFICATE_TYPE"
const UPDATE_SELECTED_PAYMENT_TYPE = "BAT2/applicationForExempted/UPDATE_SELECTED_PAYMENT_TYPE"
const UPDATE_COMPANY_CHOSEN_FOR_PAYMENT = "BAT2/applicationForExempted/UPDATE_COMPANY_CHOSEN_FOR_PAYMENT"

export default function applicationForReorderingOfCertificateReducer(state: ICreateApplicationForReorderingOfCertificateVm = new InitState().applicationForReorderingOfCertificate, action: IAction): ICreateApplicationForReorderingOfCertificateVm {
    switch (action.type) {
        case UPDATE_CERTIFICATE_TYPE:
            return { ...state, certificateType: action.payload }
        case UPDATE_CERTIFICATE_PROCESS_TYPE:
            return { ...state, certificateProcessType: action.payload }
        case UPDATE_APPLICATION_ID:
            return { ...state, applicationId: action.payload }
        case UPDATE_SELECTED_PAYMENT_TYPE:
            return { ...state, selectedPaymentType: action.payload }
        case UPDATE_COMPANY_CHOSEN_FOR_PAYMENT:
            return { ...state, companyChosenForPayment: action.payload }
        default:
            return {
                ...state,
                modifiedAddress: addressReducer(state.modifiedAddress, action),
                companyChosenForPayment: companyReducer(state.companyChosenForPayment, action)
            }
    }
}
export function updateCertificateType(certificateType: CertificateType) {
    return { type: UPDATE_CERTIFICATE_TYPE, payload: certificateType }
}
export function updateCertificateProcessType(certificateProcessType: CertificateProcessType) {
    return { type: UPDATE_CERTIFICATE_PROCESS_TYPE, payload: certificateProcessType }
}
export function updateApplicationId(appliactionId: string) {
    return { type: UPDATE_APPLICATION_ID, payload: appliactionId }
}
export function updateSelectedPaymentType(paymentType: PaymentType) {
    return { type: UPDATE_SELECTED_PAYMENT_TYPE, payload: paymentType }
}
export function updateCompanyChosenForPayment(value: ICompanyVm) {
    return { type: UPDATE_COMPANY_CHOSEN_FOR_PAYMENT, payload: value }
}